import { patch } from "../../utils/axios-config";
import { NEW_PASSWORD_FORGOT_PASSWORD, REQUEST_TOKEN_FORGOT_PASSWORD } from "../../utils/constants";

export const requestEmailPassword = async (data: any) => await patch<any, any>(REQUEST_TOKEN_FORGOT_PASSWORD, data);
export const requestNewPassword = async (data: any) => await patch<any, any>(NEW_PASSWORD_FORGOT_PASSWORD, data);